import { GradientSvg } from "./utils/gradient-svg";

import type { FC } from "react";

export const GradientStar: FC = () => (
  <GradientSvg viewBox="0 0 24 24" gradientId="gradientStar">
    <path
      fill="url(#gradientStar)"
      d="M12 17.27L18.18 21 16.54 13.97 22 9.24 14.81 8.63 12 2 9.19 8.63 2 9.24 7.46 13.97 5.82 21z"
    />
  </GradientSvg>
);
